/* eslint-disable no-console */
/* eslint-disable unicorn/prefer-module */
import React, { useMemo, useEffect } from "react";
import { useAuthContext } from "../../context/auth";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { fullScreenPlugin } from "@react-pdf-viewer/full-screen";
import { getFilePlugin } from "@react-pdf-viewer/get-file";
import "@react-pdf-viewer/full-screen/lib/styles/index.css";
import "./stylesMediakit.scss";

function Mediakit() {
  const { pais } = useAuthContext();
  const newplugin = defaultLayoutPlugin();
  const getFilePluginInstance = getFilePlugin();
  const fullScreenPluginInstance = fullScreenPlugin();

  const mediakit = useMemo(
    () =>
      ({
        Chile: require("../../pdf/mediakit-wecast.pdf"),
        Perú: require("../../pdf/mediakit-visiona.pdf"),
        Uruguay: require("../../pdf/mediakit-visiona.pdf"),
      })[pais] || require("../../pdf/mediakit-visiona.pdf"),
    [pais]
  );

  useEffect(() => {
    console.log("Mediakit loaded for:", pais, "URL:", mediakit);
  }, [pais, mediakit]);

  if (pais === "Chile") {
    return (
      <div className="pdf-container">
        <div className="iframe-wrapper">
          <iframe
            loading="lazy"
            src="https://www.canva.com/design/DAGzdivXo5Q/iYHlW_Qguibxm1aNvsA67Q/view?embed"
            allow="fullscreen"
            title="Chile Mediakit"
            style={{ width: "100%", height: "100%", minHeight: "100vh", border: "1px solid red" }} // Reforzamos dimensiones
          />
        </div>
      </div>
    );
  }

  if (pais === "Perú") {
    return (
      <div className="pdf-container">
        <div className="iframe-wrapper">
          <iframe
            loading="lazy"
            src="https://www.canva.com/design/DAGlip86IeQ/6fQEzeH16mnl2QAt_Pr3iA/view?embed"
            allow="fullscreen"
            title="Perú Mediakit"
            style={{ width: "100%", height: "100%", minHeight: "100vh", border: "1px solid red" }} // Reforzamos dimensiones
          />
        </div>
      </div>
    );
  }

  return (
    <div className="pdf-container">
      <div className="pdf-wrapper">
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
          <Viewer
            fileUrl={mediakit}
            plugins={[newplugin, getFilePluginInstance, fullScreenPluginInstance]}
            style={{ width: "100%", height: "100%", minHeight: "80vh", border: "1px solid blue" }} // Reforzamos dimensiones
          />
        </Worker>
      </div>
    </div>
  );
}

export default Mediakit;
